<template>
  <div class="grid pb-0">
    <div class="grid-title-tab">
      <div class="d-flex align-items-center">
        <v-tabs v-model="tab">
          <v-tab
            v-for="item in tabItems"
            :key="item.key"
            :disabled="item.disabled"
            @click="loadRoute(item.routeName)"
            style="width:250px;"
          >
            {{ item.title }}
          </v-tab>
        </v-tabs>
        <v-btn
          class="mx-4"
          color="primary"
          @click="bulkUpdate()"
        >
          <svg 
            height="15" 
            width="15" 
            viewBox="0 0 400 400" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="currentColor" 
            aria-hidden="true">
            <g>
              <polygon 
                points="157.055,0 90.798,196.319 164.417,196.319 88.344,400 289.571,159.509 218.405,159.509 311.656,0" 
                style="fill:currentColor;">
              </polygon>
            </g>
          </svg>
          {{$t('_BATCH_UPDATE.TITLE')}}
        </v-btn>
      </div>
    </div>
    <v-progress-linear
      color="warning"
      indeterminate
      rounded
      height="3"
      v-if="isLoading"
    ></v-progress-linear>
    <div class="grid-body border-top-unset">
      <div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";
import eventBus from "@/_helpers/event-bus.js";
export default {
  components: {},
  data() {
    return {
      isLoading: false,
      systemLang: this.$i18n.locale,
      tab: 0,
      toggle_exclusive: 0,
      view: 'table'
    };
  },
  computed: {
    tabItems() {
      return [
        {
          title: this.$t("ROOM_SALE_WITH_OTA"),
          key: "otas",
          disabled: false,
          routeName: "roomSaleWithOTAs",
        },
        {
          title: this.$t("ROOM_SALE_WITH_ROOM_TYPE"),
          key: "ota",
          disabled: false,
          routeName: "roomSaleOTA",
        },
        {
          title: this.$t("CALENDAR_ROOM"),
          key: "calendar",
          disabled: false,
          routeName: "roomSaleWithCalendar",
        },
      ];
    },
  },
  created() {
    this.fetchData();
  },
  watch: {
    "$route.query": "fetchData",
  },
  methods: {
    fetchData() {
      switch (this.$route.name) {
        case "roomSaleOTA":
          this.tab = 1;
          break;
        case "roomSaleWithOTAs":
          this.tab = 0;
          break;
        case "roomSaleWithCalendar":
          this.tab = 2;
          break;
        default:
          break;
      }
    },
    changeView(value) {
      this.view = value;
      eventBus.$emit("CHANGE_VIEW_ROOM_SALE", this.view);
    },
    bulkUpdate() {
      localStorage.setItem(
        "roomRateUpdate",
        JSON.stringify({
          roomId: -1,
          planId: -1,
          OtaId: -1,
        })
      );
      this.$router.push({
        name: "priceUpdate",
      });
    },
    loadRoute(routeName) {
      this.$router.push({ name: routeName });
    },
  },
};
</script>
